import * as React from "react";
import styled from "styled-components";
import { Nav } from "components/bootstrap";
import NavigationItem from "components/navigation/NavigationItem";
import CollapsedMainNavbar from "components/navigation/CollapsedMainNavbar";
import useNavigationItems from "components/navigation/useNavigationItems";
const ExpandedNav = styled(Nav)`
  flex: 0 0 auto;
  align-items: stretch;

  > li {
    display: inline-flex;
    align-items: stretch;
  }

  > li > a {
    display: flex;
    align-items: center;
  }
`;
const MainNavbar = ({ pathname, collapsed = false, menuRef = void 0 }) => {
  const navigationItems = useNavigationItems();
  if (collapsed) {
    return /* @__PURE__ */ React.createElement(CollapsedMainNavbar, { navigationItems });
  }
  return /* @__PURE__ */ React.createElement(ExpandedNav, { ref: menuRef }, navigationItems.map((navigationItem) => /* @__PURE__ */ React.createElement(NavigationItem, { navigationItem, pathname, key: navigationItem.description })));
};
export default MainNavbar;
